import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const envLang = process.env.REACT_APP_LANG;
const useEnvLang = !!envLang;

i18n
  .use(Backend);

if (!useEnvLang) {
  i18n.use(LanguageDetector); // use language detector only if envLang is not set
}

i18n
  .use(initReactI18next)
  .init({
    lng: envLang || undefined,          
    fallbackLng: 'de',                   
    supportedLngs: ['de', 'fr', 'pl', 'enGB'],
    interpolation: { escapeValue: false },
    backend: {
      loadPath: '/static/locales/{{lng}}.json',
    },
    detection: {
      // use this if you want to use the language detector
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
